export const getOrgMemoryEntries = async (apiClient) => {
  return apiClient.post("/v1/memory/org/list");
};

export const updateOrgMemoryEntry = async (apiClient, {entryId, ...updates}) => {
  return apiClient.post(`/v1/memory/org/update/${entryId}`, updates);
};

export const deleteOrgMemoryEntry = async (apiClient, {entryId}) => {
  return apiClient.post(`/v1/memory/org/delete/${entryId}`);
};

export const getUserMemoryEntries = async (apiClient, {email}) => {
  return apiClient.post("/v1/memory/user/list", {email});
};

export const updateUserMemoryEntry = async (apiClient, {memoryId, email, ...updates}) => {
  return apiClient.post(`/v1/memory/user/update/${memoryId}`, {email, ...updates});
};

export const deleteUserMemoryEntry = async (apiClient, {memoryId, email}) => {
  return apiClient.post(`/v1/memory/user/delete/${memoryId}`, {email});
};

export const purgeUserMemory = async (apiClient, {email}) => {
  return apiClient.post("/v1/memory/user/purge", {email});
};
